import { constant } from "lodash";

export const REPORT_ID = 'slide-20';
export const SLIDE_NUMBER = 20;